import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from '@/api/request';

Vue.use(VueRouter)

const routes = [{
    path: '/error',
    name: 'error',
    component: function () {
      return import('../views/error/index.vue')
    }
  },
  {
    path: '/',
    name: 'home',
    component: function () {
      return import('../views/Home/index.vue')
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('../views/Login/index.vue')
    }
  },
  {
    path: '/kefulist',
    name: 'kefuList',
    component: function () {
      return import('../views/kefuList/index.vue')
    }
  },
  {
    path: '/sitelist',
    name: 'siteList',
    component: function () {
      return import('../views/siteList/index.vue')
    }
  },
  {
    path: '/sitepage',
    name: 'sitePage',
    component: function () {
      return import('../views/siteList/sitePage.vue')
    }
  },
  {
    path: '/siteDetails',
    name: 'siteDetails',
    component: function () {
      return import('../views/siteList/siteDetails.vue')
    }
  },
  {
    path: '/chatlist',
    name: 'chatList',
    component: function () {
      return import('../views/chatList/index.vue')
    }
  },
  {
    path: '/documentlist',
    name: 'documentList',
    component: function () {
      return import('../views/documentList/index.vue')
    }
  },
  {
    path: '/documentDetails',
    name: 'documentDetails',
    component: function () {
      return import('../views/documentList/documentDetails.vue')
    }
  },
  {
    path: '/accountlist',
    name: 'accountList',
    component: function () {
      return import('../views/adminPage/accountList.vue')
    }
  },
  {
    path: '/blocklist',
    name: 'blockList',
    component: function () {
      return import('../views/blockList/index.vue')
    }
  },
  {
    path: '/recordlist',
    name: 'recordList',
    component: function () {
      return import('../views/recordList/index.vue')
    }
  },
  {
    path: '/aidate',
    name: 'aiDate',
    component: function () {
      return import('../views/aiDate/index.vue')
    }
  },
  {
    path: '/aistudy',
    name: 'aiStudy',
    component: function () {
      return import('../views/aiStudy/index.vue')
    }
  },
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.kct) {
    const kct = to.query.kct;
    axios.get(`/api/IMAPI/getLoginInfo?kct=${kct}`)
      .then(response => {
        // 处理成功响应
        if (response.data.code == 200) {
          localStorage.setItem('aicsMng_token', response.data.data.access_token);
          const pathArr = ['/']
          if (pathArr.indexOf(to.path) !== -1) {
            const aicsMng_token = localStorage.getItem('aicsMng_token');
            if (aicsMng_token) {
              next();
            } else {
              next('/login');
            }
          } else {
            next();
          }
        } else if (response.data.code == 1001) {
          // 跳转到错误页面 1001
          next('/login');
        } else {
          // 其他错误
          next('/login');
        }
      })
      .catch(error => {
        // 处理请求错误
        console.error(error);
        next('/login');
      });

  } else {
    const pathArr = ['/']
    if (pathArr.indexOf(to.path) !== -1) {
      const aicsMng_token = localStorage.getItem('aicsMng_token');
      if (aicsMng_token) {
        next();
      } else {
        next('/login');
      }
    } else {
      next();
    }
  }
});

// 添加错误处理逻辑
router.onError(error => {
  // 检查接口返回的状态码是否为500
  if (error.response && error.response.status == 500) {
    // 跳转到错误页面
    router.push({
      name: 'error'
    });
  } else {
    // 其他错误处理逻辑
  }
});


export default router;